import React, { Component } from 'react';
import { connect } from 'react-redux';

import styles from './_styles/EditInputElement.module.scss';

const allActionCreators = Object.assign({});

export class EditInputElement extends Component {

	formatOptions() {
		const attrs = this.props.attributeOptions || [];
		return attrs.map(attr => {
			return {
				display: attr.name,
				value: attr.data_key,
			}
		});
	}

	handleChange(evt) {
		// Returns (typeKey, attrValue)
		switch(this.props.fieldSchema?.type) {
			case 'toggle':
				this.props.onChange(this.props.fieldSchema?.stateKey, !this.props.value);
				break;
			default:
				const val = this.props.fieldSchema?.formatOnChange 
					? this.props.fieldSchema.formatOnChange(evt.target.value) 
					: evt.target.value;
				this.props.onChange(this.props.fieldSchema?.stateKey, val);
		}
	}

	inputElement() {
		switch(this.props.fieldSchema?.type) {
			case 'toggle':
				return <div className={styles.toggleWrapper}>
					<div className={styles.checkboxWrapper}>
						<input
							id={this.props.fieldSchema?.stateKey}
							type='checkbox'
							checked={!!this.props.value}
							onChange={this.handleChange.bind(this)} />
					</div>
					<div className={styles.labelWrapper}>
						<label htmlFor={this.props.fieldSchema?.stateKey}>
							{this.props.value
								? this.props.fieldSchema?.toggleTrue || 'True'
								: this.props.fieldSchema?.toggleFalse || 'False'
							}
						</label>
					</div>
				</div>
			case 'textarea':
				return <textarea
							value={this.props.value || ''}
							onChange={this.handleChange.bind(this)} />
			default:
				return <input
							type={this.props.fieldSchema?.type !== 'input'}
							value={this.props.value || ''}
							onChange={this.handleChange.bind(this)} />
		}
	}
	
	render() {
		return <div className={styles.EditInputElement}>
			<div className={styles.elemWrapper}>
				<div className={`${styles.label} EllipsisElement`}>{this.props.fieldSchema?.label || ''}</div>
				<div className={styles.inputWrapper}>
					{this.inputElement()}
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(EditInputElement);